var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMarkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.106 0H3.8147e-06V35.408H47.106V0Z",
    fill: "#DDDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6219 33.1959L42.6802 45.2088L20.5499 32.5635L37.6219 33.1959Z",
    fill: "#DDDCDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5588 21.3789C25.5588 22.4247 24.6964 23.2126 23.5538 23.2126C22.5889 23.2126 21.5479 22.512 21.5479 21.3789C21.5479 19.162 21.4606 16.6888 21.3765 14.2973C21.2916 11.8987 21.2043 9.41833 21.2043 7.18555C21.2043 5.8573 22.1922 4.89404 23.553 4.89404C24.936 4.89404 25.9016 5.83588 25.9016 7.18555C25.9016 9.41833 25.8143 11.8987 25.7302 14.2973C25.6461 16.6888 25.5588 19.162 25.5588 21.3789Z",
    fill: "#5B6075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5246 25.3882C24.9465 25.3882 26.1025 26.5443 26.1025 27.9661C26.1025 29.3713 24.9465 30.5155 23.5246 30.5155C22.1583 30.5155 21.0038 29.3475 21.0038 27.9661C21.0038 26.5443 22.1345 25.3882 23.5246 25.3882Z",
    fill: "#5B6075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkAlt);
export default __webpack_public_path__ + "static/media/exclamation-mark-alt.7c8414c7ec5a2e10a26d2e6818304252.svg";
export { ForwardRef as ReactComponent };